import { render } from "./BitacoraTables.vue?vue&type=template&id=44a6a302"
import script from "./BitacoraTables.vue?vue&type=script&lang=js"
export * from "./BitacoraTables.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__